import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ReactComponent as ArrowDownSVG } from '@common_components/svg/arrowDown.svg';

const ArrowDownIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <span className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ArrowDownSVG />
    </span>
  );
};

export { ArrowDownIcon };
